export class ApiEndPointsOrganizations {  
  addOrganization = 'api/Orgnization/AddOrganization';
  GetActiveOfficesSuperAdmin = 'api/Orgnization/GetOffices';
  getOrganization = 'api/Orgnization/GetOrganizationList';
  getOffices = 'api/Orgnization/GetOffices';
  updateOrganization = 'api/Orgnization/UpdateOrganization';
  deleteOrganization = 'api/Orgnization/DeleteOrganization';
  getCountryList = 'api/Orgnization/GetCountryValues';
  getStateList = 'api/Orgnization/GetStateValues';
  getCityList = 'api/Orgnization/GetCityValues';
  getOrganizationDomains ='api/Orgnization/GetOrganizationDomains';
  getDatabasesNames = 'api/Orgnization/GetDatabases';
  getOfficeDetail = 'api/Orgnization/GetOfficeDetail';
  getOrgModules = 'api/Orgnization/GetOrgModules';
  activeOrgModule = 'api/Orgnization/ActiveOrgModule';
  renameOrgModule = 'api/Orgnization/RenameOrgModule';
  getOfficeAdministratorList = 'api/ManageUser/GetOfficeAdministratorList';
  renameOrgName = 'api/Orgnization/RenameOffice';
  activeOrg = 'api/Orgnization/ActiveOrg'; 
  GetUserList = 'api/ManageUser/GetUserList';
  getImageUploadURL = 'api/App/UploadProfilePic';
  UploadOfficeLogo = 'api/Orgnization/UploadOfficeLogo';

  addSMTP="api/Orgnization/AddSMTP";
  getOfficeMailConfigration="api/Orgnization/GetOfficeMailConfigration";
  testCustomSMTP ="api/Auth/TestCustomSmtp";
  testSmtpAPI="api/Auth/TestSmtpAPI";
  addEmailSignature="api/Orgnization/AddEmailSignature";
  uploadPortalbackgroundImage="api/Orgnization/UploadPortalbackgroundImage";
  importFormsfromAOffice="api/Project/ImportFormsfromAOffice";
  importProcesssStagesfromAOffice="api/Dashboard/ImportProcessStages";
  importScreenFieldsfromAOffice="api/Dashboard/ImportScreenFields";
  importFileManagerFoldersFromAOffice="api/FileManager/ImportFileManagerFoldersFromAOffice";
  importQuestionTemplatesFromAOffice="api/NLPTemplate/ImportQuestionTemplatesFromAOffice";
  importFieldTemplatesFromAOffice="api/OCRTemplate/ImportFieldTemplatesFromAOffice";
  importAIAutomationTemplateFromAOffice="api/AIAutomation/ImportAIAutomationTemplateFromAOffice";
}
